import {
	isContractor,
	isSupplierPayingCustomer,
	nullSafeGet,
	nullSafeGetOrElse,
	recordHasContractorId,
} from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	invoicesRestCrudThunksForBuyer,
	invoicesRestCrudThunksForSupplier,
	invoicesSubcontractorRestCrudThunks,
	invoicesContractorRestCrudThunks,
} from '../../thunks/invoices_thunks';
import { getSanitisedInvoice, getSanitisedQuote } from '../../utils/WorkOrderUtils';
import { isBuyerOrInternalTech } from '../../utils/AuthUtils';
import { SupplierFacilityName } from '../name_component/supplierFacility/supplierFacilityNameComponent';
import { BuyerCompanyName } from '../name_component/buyerCompany/buyerCompanyNameComponent';
import React from 'react';
import { isClientQuoteView } from '../quote_utils/QuoteUtils';

export const isClientInvoiceViewLocation = (location) =>
	!nullSafeGetOrElse('pathname', location, '').includes('subcontractor');
export const isSubcontractorInvoiceViewLocation = (location) =>
	nullSafeGetOrElse('pathname', location, '').includes('subcontractor');

export const getInvoiceSubUrl = (userType, currentUser, record) => {
	const hasContractorId = recordHasContractorId(record);
	const isClientView = !isContractor(currentUser, record);
	return userType === ROLE_TYPES.SUPPLIER
		? hasContractorId
			? isClientView
				? 'supplier/invoices/contractor'
				: 'supplier/invoices/subcontractor'
			: 'supplier/invoices'
		: 'buyer/invoices';
};

export const getInvoicePathName = (userType, currentUser, record) => {
	const hasContractorId = recordHasContractorId(record);
	const isClientView = !isContractor(currentUser, record);
	return userType === ROLE_TYPES.SUPPLIER
		? hasContractorId
			? isClientView && isSupplierPayingCustomer(currentUser)
				? 'supplier/invoices/contractor'
				: 'supplier/invoices/subcontractor'
			: 'supplier/invoices'
		: 'buyer/invoices';
};

export const getInvoiceSubAPIURL = (userType, currentUser, record) => {
	const hasContractorId = recordHasContractorId(record);
	const isClientView = !isContractor(currentUser, record);
	return userType === ROLE_TYPES.SUPPLIER
		? hasContractorId
			? isClientView
				? 'supplier/invoice/contractor_invoices'
				: 'supplier/invoice/subcontractor_invoices'
			: 'supplier/invoice/invoices'
		: 'buyer/invoice/invoices';
};

export const getInvoiceRestCrudThunksFromPath = (userType, location) =>
	userType === ROLE_TYPES.BUYER
		? invoicesRestCrudThunksForBuyer
		: nullSafeGetOrElse('pathname', location, '').includes('supplier/invoices/contractor')
		? invoicesContractorRestCrudThunks
		: nullSafeGetOrElse('pathname', location, '').includes('supplier/invoices/subcontractor')
		? invoicesSubcontractorRestCrudThunks
		: invoicesRestCrudThunksForSupplier;

export const getInvoiceRestCrudThunksContractorId = (
	userType,
	hasContractorId,
	isClientView = false
) =>
	userType === ROLE_TYPES.SUPPLIER
		? hasContractorId
			? isClientView
				? invoicesContractorRestCrudThunks
				: invoicesSubcontractorRestCrudThunks
			: invoicesRestCrudThunksForSupplier
		: invoicesRestCrudThunksForBuyer;

export const isClientInvoiceView = (invoice, currentUser) => {
	if (invoice.subSupplierFacilityId === undefined) return true;
	return invoice.subSupplierFacilityId === nullSafeGet('facility.id', currentUser);
};

export const getInvoiceOtherCompanyEntity = (invoiceItem, currentUser) => {
	const invoice = getSanitisedInvoice(invoiceItem);
	const isContractorWorkOrder = recordHasContractorId(invoice);
	if (isBuyerOrInternalTech(currentUser)) {
		return nullSafeGet('supplierFacility', invoice);
	} else if (isContractorWorkOrder) {
		if (isClientInvoiceView(invoice, currentUser)) {
			return nullSafeGet('contractorSupplierFacility', invoice);
		} else {
			return nullSafeGet('subSupplierFacility', invoice);
		}
	} else {
		return nullSafeGet('workOrder.buyerCompany', invoice);
	}
};

export const getInvoiceOtherCompany = (invoiceItem, currentUser) => {
	const invoice = getSanitisedInvoice(invoiceItem);
	const isContractorWorkOrder = recordHasContractorId(invoice);
	if (isBuyerOrInternalTech(currentUser)) {
		//Return normal third party supplier
		return (
			<SupplierFacilityName
				facility={nullSafeGet('supplierFacility', invoice)}
				mode={'card'}
				placement={'top'}
				allowHover={false}
			/>
		);
	} else if (isContractorWorkOrder) {
		if (isClientQuoteView(invoice, currentUser)) {
			return (
				<SupplierFacilityName
					facility={nullSafeGet('contractorSupplierFacility', invoice)}
					mode={'card'}
					placement={'top'}
					allowHover={false}
				/>
			);
		} else {
			return (
				<SupplierFacilityName
					facility={nullSafeGet('subSupplierFacility', invoice)}
					mode={'card'}
					placement={'top'}
					allowHover={false}
				/>
			);
		}
	} else {
		return (
			<BuyerCompanyName
				company={nullSafeGet('workOrder.buyerCompany', invoice)}
				mode={'card'}
				placement={'top'}
				allowHover={false}
			/>
		);
	}
};

export const getInvoiceMissingProperties = (invoice) => {
	const missingInvoiceNumber = invoice.invoiceNumber === undefined;
	const missingDateOfInvoice = invoice.dateOfInvoice === undefined;
	const missingPDFLink = nullSafeGetOrElse('invoicePDFLink', invoice, []).length === 0;
	const missingAProperty = missingPDFLink || missingDateOfInvoice || missingInvoiceNumber;
	return { missingInvoiceNumber, missingDateOfInvoice, missingPDFLink, missingAProperty };
};
